const WechatOpenid = 'Admin-Openid'
const Storage = window.localStorage;

export function getOpenid() {
  if(process.env.NODE_ENV === 'development'){
    console.log('using development env, set wechat open id: dev-wechat-openid');
    return 'dev-wechat-openid';
  }
    return Storage.getItem(WechatOpenid)
}

export function setOpenid(Openid) {
    return Storage.setItem(WechatOpenid, Openid)
}

export function removeOpenid() {
    return Storage.removeItem(WechatOpenid)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js